<template>
	<router-view :instructions="instructions" :paymentMode="selectedGateway">
	</router-view>
	<!-- <component :is="paymentOption" :instructions="instructions" :paymentMode="selectedGateway"></component> -->
</template>

<script>
import { mapActions, mapState } from "vuex";
import Cash from "../components/Payment/Cash.vue";
import BankTransfer from "../components/Payment/BankTransfer.vue";
export default {
	name: "Payment",
	data() {
		return {
			instructions: null,
			selectedGateway: null,
		};
	},
	computed: {
		...mapState("appState", ["externalServicesList"]),
		paymentOption() {
			return this.$route.name;
		},
	},
	methods: {
		...mapActions("appState", ["fetchExternalServices"]),
	},
	created() {
		if (!this.externalServicesList.PaymentGateway) {
			this.fetchExternalServices("PaymentGateway").then(() => {
				var paymentGateway = this.externalServicesList.PaymentGateway.find(
					(gateway) => gateway.serviceProvider.toLowerCase() === this.paymentOption.toLowerCase()
				);

        if(paymentGateway.serviceData) {
          this.instructions = JSON.parse(paymentGateway.serviceData).Instructions;
        }

				this.selectedGateway = paymentGateway;
			});
		} else {
			var paymentGateway = this.externalServicesList.PaymentGateway.find(
				(gateway) => gateway.serviceProvider.toLowerCase() === this.paymentOption.toLowerCase()
			);

      if(paymentGateway.serviceData) {
        this.instructions = JSON.parse(paymentGateway.serviceData).Instructions;
      }

			this.selectedGateway = paymentGateway;
		}
	},
	components: {
		Cash,
		BankTransfer,
	},
};
</script>

<style scoped>
</style>
